import React from 'react';
import './Styles/Container.scss';

const Section=(props)=>{
    return(
        <div className="section-terms" id={props.id}>
        {props.title ? <h3>{props.title}</h3> : null}
        {props.desc ? <p>{props.desc}</p> : null}
        {props.desc2 ? <p>{props.desc2}</p> : null}
        </div>
    )
};
export default Section ;